import { isProduction } from '#app/utils/is-production'

export const addToCartEventMeta = (selectedSku: string, eventData: any) => {
	if (typeof window.fbq === 'function' && isProduction()) {
		window.fbq('track', 'AddToCart', {
			content_ids: [selectedSku],
			content_name: eventData.name,
			content_type: 'product',
			value: eventData.price,
			currency: 'DKK',
			content_category: eventData.gender,
		})
	}
	const eventDataPixel = {
		content_ids: [selectedSku],
		content_name: eventData.name,
		content_type: 'product',
		value: eventData.price,
		currency: 'DKK',
		content_category: eventData.gender,
	}
	const formData = new FormData()
	formData.append('eventType', 'AddToCart')
	formData.append('eventData', JSON.stringify(eventDataPixel))
}
